import { renderComponent, destroyComponent } from "../dom";
import { cr } from "fire-wind-water";
import { settings } from "../common/setting";

function updateSearchParam(
  key: string,
  value: string | number,
  originalUrl?: string
): string {
  const rurl: string = originalUrl || window.location.href;
  const urls: any = rurl.match(/([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/);
  if (!urls) {
    return rurl;
  }
  const url: string = urls[1] || "";
  let searchURL: string = urls[2] || "";
  const routerURL: string = urls[3] || "";
  const routerParam: string = urls[4] || "";
  if (searchURL) {
    const searchs: string[] = searchURL.replace(/^\?/, "").split("&");
    const newSearch: string[] = [];
    const newSearchJson: { [label: string]: boolean } = {};
    for (const items of searchs) {
      const reg = /([^=]+)=(.+)/;
      const item: string[] = items.match(reg);
      if (item) {
        newSearchJson[item[0]] = true;
        if (item[0] === key) {
          newSearch.push(`${item[1]}=${value}`);
        } else {
          newSearch.push(`${item[1]}=${item[2]}`);
        }
      }
    }
    if (!newSearchJson[key]) {
      newSearch.push(`${key}=${value}`);
    }
    searchURL = `?${newSearch.join("&")}`;
  } else {
    searchURL = `?${key}=${value}`;
  }
  return url + searchURL + routerURL + routerParam;
}

class DomRelated {
  skAfterViewChecked(): void {
    const alist: NodeListOf<HTMLElement> =
      document.querySelectorAll(".goto-link");
    const urlReg: any =
      /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
    cr.each(alist, (d) => {
      if (!d.href || d.href.indexOf("javascript") !== -1) {
        return;
      }
      //域名在白名单里
      if (
        settings.pk_campaign &&
        settings.urls.indexOf(urlReg.exec(d.href)[0]) > -1
      ) {
        d.href = updateSearchParam("pk_campaign", settings.pk_campaign, d.href);
      }
      if (settings.channel_code) {
        d.href = updateSearchParam("pk_source", settings.channel_code, d.href);
      }
      if (settings.isNotLink === 1) {
        d.href = updateSearchParam("isNotLink", 1, d.href);
      }
    });
    renderComponent();
  }

  skOnDestroy(): void {
    destroyComponent();
  }
}

export { DomRelated };
